import { Pipe, PipeTransform } from "@angular/core";

import { AssetFragment } from "../../common/generated-types";
import { NO_IMAGE_PLACEHOLDER } from "../../common/constants";
import { isSupplierNoImagePlaceholder } from "../utils/product-image.utils";

@Pipe({
    name: "assetPreview",
})
export class AssetPreviewPipe implements PipeTransform {
    transform(asset?: AssetFragment, ...args: Array<string | number>): string {
        if (
            !asset?.preview ||
            typeof asset.preview !== "string" ||
            isSupplierNoImagePlaceholder(asset.preview, asset.id)
        ) {
            return NO_IMAGE_PLACEHOLDER;
        }
        const previewUrl = asset.preview.replace(/\\/g, "/");
        const fp = asset.focalPoint
            ? `&fpx=${asset.focalPoint.x}&fpy=${asset.focalPoint.y}`
            : "";
        const query = this.getSizeQuery(args);
        return `${previewUrl}?${query}${fp}&format=webp`;
    }

    private getSizeQuery(args?: Array<string | number>): string {
        if (!args) {
            return `preset=thumb`;
        }
        if (args.length === 1) {
            if (typeof args[0] === "string") {
                return `preset=${args[0]}`;
            } else {
                return `w=${args[0]}`;
            }
        } else {
            return `w=${args[0]}&h=${args[1]}`;
        }
    }
}
